import Formular from "../components/Formular";

function Home() {

    return (
        <div className="min-h-screen bg-gray-100 p-6">
            <Formular />
        </div>
    );
}

export default Home